<template>
  <div>
    <div class="order-modal-allocation">
      <h3>{{ $t("חלוקת חדרים") }}</h3>

      <div class="allocation-rooms">
        <div v-for="(room, i) in form.rooms" :key="i" class="allocation-room">
          <div class="room-head">
            <span>
              <span>{{ room.name }}</span>
              <span>|</span>
              <span style="direction: ltr">&euro;{{ room.price }}</span>
            </span>
            <div>
              <!-- <div class="room-count">{{ room.wantedCount }}</div> -->
              <i
                :class="{
                  'icon icon-chevron-down-black room-expand': true,
                  expanded: !hiddenRooms[room.id]
                }"
                @click="expandRoom(room)"
              ></i>
            </div>
          </div>
          <div v-if="!hiddenRooms[room.id]" class="room-body">
            <div
              v-for="(passenger, passengerIndex) in room.passengers"
              :key="passengerIndex"
              class="room-passenger"
              :class="{ 'with-birthdate': isBirthDateRequired }"
            >
              <div class="passenger-head">
                <div class="passenger-right">
                  <div class="passenger-icon">
                    <svg
                      width="15"
                      height="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#8BE1FC" fill-rule="nonzero">
                        <path
                          d="M12.832 17.768l-4.381-2.316 1.466-2.774.3-.562c.166-.312.166-.67.029-.97l1.89-1.154.038-.025.309.366a.625.625 0 001.037-.12.876.876 0 00.162-1.158l1.029-.63a.3.3 0 00.112-.399.29.29 0 00-.404-.104l-1.079.658-.037.025-2.911-3.47-.642-.812a1.485 1.485 0 00-2.453.18l-2.132 3.69a1.685 1.685 0 00.67 2.328l1.108.583 1.204.637-3.116 1.9-4.098-2.166A.635.635 0 10.342 12.6l3.427 1.81-1.732 1.059-.246-.304a.301.301 0 00-.412-.059.29.29 0 00-.05.417l.204.254-.575.35a.3.3 0 00-.113.4.29.29 0 00.255.145c.05 0 .104-.012.15-.041l.65-.396.266.33a.292.292 0 00.416.037.298.298 0 00.03-.413l-.209-.258 1.962-1.195 7.872 4.16c2.107.963 2.657-1.299 2.67-1.357-.496.983-2.075.229-2.075.229zM9.754 10.62l-.562-.3-1.374-.725 1.645-2.853 2.332 2.778-1.924 1.17c-.037-.024-.075-.05-.117-.07zm-4.123 3.34l2.416-1.47L6.91 14.64l-1.279-.679z"
                        />
                        <circle cx="10.392" cy="1.678" r="1.649" />
                      </g>
                    </svg>
                  </div>
                  <div class="passenger-title">
                    <h4>{{ $t("נוסע") }} {{ passengerIndex + 1 }}</h4>
                    <span>{{
                      $t("נא להזין שם מלא באנגלית כפי שמופיע בדרכון")
                    }}</span>
                  </div>
                </div>
                <div
                  class="passenger-remove"
                  v-if="canRemovePassenger(room)"
                  @click="removePassenger(room, passengerIndex)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M408.299 98.512l-32.643 371.975H136.344L103.708 98.512l-41.354 3.625 33.232 378.721C97.335 498.314 112.481 512 130.076 512h251.849c17.588 0 32.74-13.679 34.518-31.391l33.211-378.472-41.355-3.625z"
                    />
                    <path
                      d="M332.108 0H179.892c-19.076 0-34.595 15.519-34.595 34.595v65.73h41.513V41.513h138.378v58.811h41.513v-65.73C366.703 15.519 351.184 0 332.108 0z"
                    />
                    <path
                      d="M477.405 79.568H34.595c-11.465 0-20.757 9.292-20.757 20.757s9.292 20.757 20.757 20.757h442.811c11.465 0 20.757-9.292 20.757-20.757s-9.293-20.757-20.758-20.757z"
                    />
                  </svg>
                  {{ $t("הסר") }}
                </div>
              </div>
              <div class="passenger-body">
                <div class="passenger-details">
                  <div class="passenger-input">
                    <label>
                      <span>
                        {{ $t("שם פרטי") }}
                      </span>
                      <input type="text" v-model="passenger.firstName" />
                    </label>
                  </div>
                  <div class="passenger-input">
                    <label>
                      <span>{{ $t("שם משפחה") }}</span>
                      <input type="text" v-model="passenger.lastName" />
                    </label>
                  </div>
                  <div class="passenger-input">
                    <label>
                      <span>{{ $t("תואר") }}</span>
                      <select v-model="passenger.type">
                        <option value="M">{{ $t("MR (זכר)") }}</option>
                        <option value="MS">{{ $t("MS (נקבה)") }}</option>
                      </select>
                    </label>
                  </div>
                  <div v-if="isBirthDateRequired" class="passenger-input">
                    <label>
                      <span>{{ $t("תאריך לידה") }}</span>
                      <input
                        type="date"
                        :value="formatDate(passenger.birthDate)"
                        @input="passenger.birthDate = $event.target.valueAsDate"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-passenger-btn">
              <button v-if="canAddPassenger(room)" @click="addPassenger(room)">
                {{ $t("+ הזן פרטי נוסע נוסף לחדר זה") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!validPassengerNames" class="passenger-details-error">
      {{ $t("פרטי הנוסעים צריכים להיות באנגלית בלבד") }}
    </div>

    <template v-if="submitting">
      <div class="submit-anim">
        <img v-if="submitting" :src="snowflake" />
        <span>כמה רגעים... החופשה המוש(לגת) בדרך אליך</span>
      </div>
    </template>

    <ModalNextButton
      v-else
      @next="onNext"
      @back="$emit('done', { event: 'back' })"
      :loading="submitting"
      :disabled="submitting || !canSubmit()"
    />
  </div>
</template>

<script>
import ModalNextButton from "./ModalNextButton.vue";
import CountControl from "./CountControl.vue";
import Datepicker from "@sum.cumo/vue-datepicker";
import "@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css";
import { he } from "@sum.cumo/vue-datepicker/dist/locale";
import { api } from "../../API";
import { $t } from "../../i18n";

// TODO: upgrade Datepicker to fork: https://sumcumo.github.io/vue-datepicker/guide/Props/

export default {
  components: { ModalNextButton, CountControl, Datepicker },

  props: {
    value: {
      type: Object
    },
    data: {
      type: Object
    },
    packageData: {
      type: Object
    }
  },

  data() {
    return {
      snowflake: require("../../../images/snowflake.gif"),
      he: he,
      form: this.value || {},
      submitting: false,
      hiddenRooms: {},
      siteData: window.siteData
    };
  },

  methods: {
    formatDate(d) {
      return (
        d &&
        new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000)
          .toISOString()
          .split("T")[0]
      );
    },

    onNext() {
      this.submitting = true;

      $.ajax({
        method: "POST",
        url: "https://skideal-orders.ynadev.com/api/orders/create",
        data: JSON.stringify({ ...this.packageData, ...this.form }),
        contentType: "application/json",
        headers: {
          Accept: "application/json"
        }
      })
        .done(resp => {
          api
            .ordersSaveLead(this.packageData.internalId, {
              name: this.value.customer.name,
              phone: this.value.customer.phone,
              status: $t("בוצעה הזמנה"),
              people: this.people,
              odysseyLink: resp.orderLink
            })
            .finally(() => {
              if (window.innerWidth <= 480) {
                if (this.siteData.no_mobile_popup) {
                  // Hide this modal.
                  window.createOrderModalState.packageData = null;
                  $(".no-continue-order-modal")
                    .modal()
                    .show();
                  return;
                }

                $(".continue-order-modal .continue-order-link").attr(
                  "href",
                  resp.orderLink
                );

                // Hide this modal.
                window.createOrderModalState.packageData = null;

                // Show continue order modal.
                $(".continue-order-modal")
                  .modal()
                  .show();
              } else {
                window.location.href = resp.orderLink;
              }

              // this.$emit("done", { event: "next" });

              // this.submitting = false;
            });
        })
        .fail(err => {
          this.$emit("done", { event: "error", error: err });
          console.log("err", err);
          this.submitting = false;
        });
    },

    canSubmit() {
      return (
        this.form.rooms.every(
          room =>
            room.passengers.length > 0 &&
            room.passengers.every(
              passenger =>
                (!this.isBirthDateRequired || passenger.birthDate) &&
                passenger.firstName.length > 0 &&
                passenger.lastName.length > 0 &&
                passenger.type
            )
        ) && this.validPassengerNames
      );
    },

    expandRoom(room) {
      this.$set(this.hiddenRooms, room.id, !this.hiddenRooms[room.id]);
    },

    addPassenger(room) {
      room.passengers.push({
        firstName: "",
        lastName: "",
        type: "M",
        birthDate: null
      });
    },

    removePassenger(room, index) {
      room.passengers.splice(index, 1);
    },

    canRemovePassenger(room) {
      const roomInfo = this.data.roomInfos.find(v => v.roomType === room.type);

      if (!roomInfo || !roomInfo.maxPeople) {
        return true;
      }

      // If there are babies, allow adding passengers above the limits.
      if (this.peopleByAge(2) > 0) {
        return true;
      }

      if (room.passengers.length > roomInfo.maxPeople) {
        return true;
      }

      // Disallow adding more than the maximum asked for amount of passengers.
      if (
        room.passengers.length >
        this.peopleByAge(18) + this.peopleByAge(12)
      ) {
        return true;
      }

      return false;
    },

    canAddPassenger(room) {
      const roomInfo = this.data.roomInfos.find(v => v.roomType === room.type);

      if (!roomInfo || !roomInfo.maxPeople) {
        return true;
      }

      // If there are babies, allow adding passengers above the limits.
      if (this.peopleByAge(2) > 0) {
        return true;
      }

      // Disallow adding more than the maximum allowed
      // amount of passengers into this room.
      if (room.passengers.length >= roomInfo.maxPeople) {
        return false;
      }

      // Disallow adding more than the maximum asked for amount of passengers.
      if (
        room.passengers.length >=
        this.peopleByAge(18) + this.peopleByAge(12)
      ) {
        return false;
      }

      // const adults = this.passengersByAge(room, 18);
      // const children = this.passengersByAge(room, 12) - adults;
      // const babies = this.passengersByAge(room, 2) - children - adults;

      // if (
      //   adults > this.peopleByAge(18) &&
      //   children > this.peopleByAge(12) &&
      //   babies > this.peopleByAge(2)
      // ) {
      //   return false;
      // }

      // return (
      //   adults <= roomInfo.maxAdults &&
      //   children <= roomInfo.maxPeople - roomInfo.minAdults
      // );

      return true;
    },

    peopleByAge(age) {
      let people = 0;

      for (const i in this.value.ageGroups) {
        const group = this.value.ageGroups[i];

        if (age == group.age) {
          people += group.wantedCount;
        }
      }

      return people;
    },

    passengersByAge(room, minimumAge) {
      let people = 0;

      for (const i in room.passengers) {
        const passenger = room.passengers[i];
        const age = passenger.birthDate
          ? (new Date() - passenger.birthDate) / 365 / 86400 / 1e3
          : 0;

        if (age >= minimumAge) {
          people++;
        }
      }

      return people;
    }
  },

  computed: {
    validPassengerNames() {
      let valid = true;

      this.form.rooms.forEach(room => {
        if (room.passengers && room.passengers.length > 0) {
          room.passengers.forEach(passenger => {
            if (
              !/^[a-zA-Z ]+$/.test(passenger.firstName) ||
              !/^[a-zA-Z ]+$/.test(passenger.lastName)
            ) {
              valid = false;
            }
          });
        }
      });

      return valid;
    },

    people() {
      let people = 0;

      for (let i in this.value.ageGroups) {
        const group = this.value.ageGroups[i];

        if (group.age >= 12) {
          people += group.wantedCount || 0;
        }
      }

      return people;
    },

    isBirthDateRequired() {
      return this.value.ageGroups.some(
        group => group.age < 18 && group.wantedCount > 0
      );
    }
  },

  watch: {
    value() {
      this.form = JSON.parse(JSON.stringify(this.value));
    }
  }
};
</script>

<style lang="scss" scoped>
.passenger-details-error {
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: -10px;
}

.submit-anim {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    max-width: 150px;
  }

  span {
    font-weight: bold;
    font-size: 19px;
  }
}

.order-modal-allocation {
  padding: 60px;
  padding-bottom: 20px;

  @media screen and (max-width: 991px) {
    padding: 60px 15px 20px 15px;
  }

  h3 {
    color: #2f3a4c !important;
    font-size: 19px !important;
    font-weight: 900 !important;
    margin: 0 0 20px 0 !important;
    text-align: center;
  }

  .allocation-rooms {
    .allocation-room {
      margin-top: 30px;

      .room-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #ececec;
        padding: 10px 15px;

        > span {
          display: flex;

          span:nth-child(2) {
            margin: 0 4px;
          }
        }

        div {
          display: flex;
          align-items: center;
          user-select: none;

          .room-count {
            color: #67d3f2;
            font-size: 19px;
            font-weight: 900;
            background-color: #231454;
            width: 23px;
            height: 23px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 20px;
            border-radius: 50%;
          }

          .room-expand {
            cursor: pointer;
            padding: 8px;
            margin: -8px;

            &.expanded {
              transform: rotate(180deg);
            }
          }
        }
      }

      .room-body {
        background-color: #f8f8f8;
        box-shadow: 0 21px 23px -20px rgba(0, 0, 0, 0.24);
        padding: 0;
        padding-bottom: 20px;

        .room-passenger {
          padding: 20px;

          &:not(:last-child) {
            border-bottom: 1px solid rgba(115, 115, 115, 0.11);
          }

          .passenger-head {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .passenger-right {
              display: flex;
              align-items: center;
              justify-content: center;

              .passenger-icon {
                height: 30px;
                width: 30px;
                background-color: #201651;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-left: 10px;
              }

              .passenger-title {
                h4 {
                  font-size: 19px;
                  font-weight: bold;
                  margin: 0;
                  line-height: 0.9;
                }

                span {
                  color: #636363;
                  font-size: 12px;
                }
              }
            }

            .passenger-remove {
              display: flex;
              align-items: center;
              font-size: 15px;
              font-weight: bold;
              padding: 6px;
              cursor: pointer;

              &:hover {
                background-color: rgba(0, 0, 0, 0.08);
                border-radius: 8px;
              }

              svg {
                margin-left: 5px;
              }
            }
          }

          .passenger-body {
            .passenger-details {
              display: flex;
              align-items: flex-end;
              margin-top: 20px;
              padding-right: 40px;

              @media screen and (max-width: 991px) {
                flex-wrap: wrap;
                padding-right: 0;
              }

              .passenger-input {
                flex-basis: 33.32%;
                line-height: 12px;

                &:not(:last-child) {
                  margin-left: 18px;
                }

                @media screen and (max-width: 991px) {
                  flex-basis: 46%;
                  max-width: 46%;
                  margin-top: 10px;

                  &:nth-child(2),
                  &:nth-child(4) {
                    margin-left: 0;
                  }

                  &:last-child {
                    flex-basis: 96%;
                    max-width: 96%;
                  }
                }

                label {
                  margin: 0;

                  span {
                    color: #636363;
                    font-size: 12px;
                  }
                }
              }
            }
          }

          &.with-birthdate {
            .passenger-body {
              .passenger-details {
                .passenger-input {
                  flex-basis: 25%;

                  @media screen and (max-width: 991px) {
                    flex-basis: 46%;
                    max-width: 46%;

                    &:last-child {
                      flex-basis: 46%;
                      max-width: 46%;
                    }
                  }
                }
              }
            }
          }
        }

        .add-passenger-btn {
          padding-top: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          button {
            color: #231454;
            font-size: 19px;
            font-weight: bold;
            text-align: center;
            background: transparent;
            border-radius: 8px;

            &:hover {
              background-color: rgba(0, 0, 0, 0.08);
            }

            &:disabled {
              opacity: 0.2;
            }
          }
        }
      }
    }
  }
}
</style>
